import api from "./apiLogisticsTool.js";

export default {
  GetOperators() {
    return api.post("GridElement/GetOperators");
  },

   
  Call(url, arg, type) {
    if (type == "post")
      return api.post(url, arg);
    else if (type == "get")
      return api.get(url + "/" +arg);
      else if (type == "delete")
      return api.delete(url + "/" +arg);
  },
};
